import { baseEntityReducers, baseInitialState } from './base/baseModelStore';
import { fetchEntitiesMap } from './base/baseModelThunks';
import { ModelReducers } from './modelReducers';
import { createSlice } from '@reduxjs/toolkit';
import { httpClient } from '../infrastructure/http/HttpClient';
import { AxiosResponseTransformer } from 'axios';
import { AppThunk } from '@root/store/store';
import { NoteDetails } from '@api-model/models';

const slice = createSlice({
  name: ModelReducers.notes,
  initialState: baseInitialState<NoteDetails[]>(),
  reducers: {
    ...baseEntityReducers(),
  },
});

const actions = slice.actions;
const addNote = (text: string, eventId: string): AppThunk => async (dispatch) => {
  try {
    dispatch(actions.startLoading());
    const { status } = await httpClient.post(`notes`, {
      EventId: eventId,
      Text: text,
    });
    if (status === 200) {
      dispatch(getEntities([eventId]));
    }
  } catch (err) {
    dispatch(actions.loadingFailed(err.toString()));
  }
};

const getEntities = fetchEntitiesMap(ModelReducers.photos, slice.actions, ([id]) =>
  httpClient.get(`notes?eventId=${id}`, {
    transformResponse: (httpClient.defaults.transformResponse as AxiosResponseTransformer[]).concat(
      (data: NoteDetails[]) => {
        return {
          [id]: data,
        };
      }
    ),
  })
);

const thunks = {
  addNote,
  getEntities,
};

export const notesEntity = {
  reducer: slice.reducer,
  actions: slice.actions,
  thunks,
} as {
  reducer: typeof slice.reducer;
  actions: typeof slice.actions;
  thunks: typeof thunks;
};
